import { Badge } from "@/components/ui/badge";
import { ProgressCircle } from "@/components/ui/charts/progress-circle";
import { mapQuestionnaireResultStatusToLabel } from "@/mappers/results";
import { PreviousEditionsResponseContent } from "@/requests/questionnaries/previous-editions.request";
import { StatusColor } from "@/types/quizzes";
import { ColumnDef } from "@tanstack/react-table";
import { ActionsCell } from "./actions-cell";
import DimensionCell from "./dimension-cell";

export const columns: ColumnDef<PreviousEditionsResponseContent>[] = [
  {
    accessorKey: "edition.name",
    header: "Edición",
  },
  {
    id: "result",
    header: "Resultado",
    cell: ({ row }) => {
      const status = row.original.result.resultStatus;
      const label = mapQuestionnaireResultStatusToLabel(status);
      const backgroundColor = StatusColor[status];

      return (
        <Badge
          style={{
            backgroundColor,
          }}
        >
          {label}
        </Badge>
      );
    },
  },
  {
    id: "dimension1",
    header: () => <span className="whitespace-nowrap">Dimensión 1</span>,
    cell: ({ row }) => <DimensionCell row={row} dimensionId="GOVERNANCE" />,
  },
  {
    id: "dimension2",
    header: () => <span className="whitespace-nowrap">Dimensión 2</span>,
    cell: ({ row }) => (
      <DimensionCell row={row} dimensionId="BUSINESS_MODEL_AND_INNOVATION" />
    ),
  },
  {
    id: "dimension3",
    header: () => <span className="whitespace-nowrap">Dimensión 3</span>,
    cell: ({ row }) => <DimensionCell row={row} dimensionId="ENVIRONMENTAL" />,
  },
  {
    id: "dimension4",
    header: () => <span className="whitespace-nowrap">Dimensión 4</span>,
    cell: ({ row }) => <DimensionCell row={row} dimensionId="SOCIAL" />,
  },
  {
    id: "totalScore",
    header: "Puntaje",
    cell: ({ row }) => {
      const status = row.original.result.resultStatus;
      const backgroundColor = StatusColor[status];

      return (
        <ProgressCircle
          value={row.original.result.score}
          radius={26}
          backgroundVariant={"neutral"}
          foregroundColor={backgroundColor}
        >
          <strong className="text-xs">{row.original.result.score}</strong>
        </ProgressCircle>
      );
    },
  },
  {
    id: "actions",
    header: "",
    cell: ({ row }) => <ActionsCell editionId={row.original.edition.id} />,
  },
];
